import { useContext, useEffect, useState } from "react"

import { WebSocketContext } from "../../../../../Providers/WebSocket/WebSocketContext"
import { showNotify } from "../../../../../Utils/Utils"
import CardAutomacao from "./CardAutomacao/CardAutomacao"

const AutomacaoTab = ({ setOpenCadastro, idCentral }) => {
    const { addRoute, sendWs } = useContext(WebSocketContext)

    const [automacaoList, setAutomacaoList] = useState(null)
    const [loading, setLoading] = useState(true)

    const getDadosIniciais = (msg) => {
        if (msg.data.status) {
            setAutomacaoList(msg.data.automacoes)
            setLoading(false)
        } else {
            showNotify(msg.message)
            setOpenCadastro(false)
        }
    }

    useEffect(() => {
        setLoading(true)
        addRoute("buscarTodasAutomacoes", getDadosIniciais)
        sendWs("buscarTodasAutomacoes", { condId: idCentral })
    }, [])

    return (
        <div style={{ height: '100%', width: '100%' }}>

            {(!loading && automacaoList) &&
                automacaoList.map((automacao, index) => {
                    return (
                        <CardAutomacao
                            key={index}
                            id={automacao.id}
                            index={index}
                            automacao={automacao}
                            idCentral={idCentral}
                        />
                    )
                })
            }
        </div>
    )
}

export default AutomacaoTab
